module.exports = __webpack_public_path__ + "img/pro_ten_2.f27bde3c.jpg";